/*
 * @Author: Teemo Ding
 * @Date: 2021-06-25 11:21:36
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 13:11:46
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Invoice/config.tsx
 */
import React from 'react';
import css from './css.module.less';

export const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '',
    name: getI18n('settings.list.invoice'),
  },
];

export const columns = (
  deleteInformation,
  editInformation,
  disable,
  { getI18n },
) => [
  {
    title: getI18n('storeInvoice.detail.information'),
    dataIndex: 'information',
    default: true,
    optional: true,
    key: 'information',
    className: css.columnClass,
    minWidth: 300,
    childGenerate: (text, record) => (
      <div className={css.informationContain}>
        <div className={css.informationTitle}>{record.title}</div>
        <div>{record.content}</div>
      </div>
    ),
  },
  disable
    ? {}
    : {
        title: getI18n(
          'general.advancedFilters.commonStoreProductsWithTable.actions',
        ),
        dataIndex: 'actions',
        default: true,
        optional: true,
        key: 'actions',
        className: css.columnClass,
        width: 126,
        align: 'center',
        childGenerate: (text, record) => (
          <div className={css.actionContain}>
            <div
              className={css.delete}
              onClick={() => {
                deleteInformation(record);
              }}>
              Delete
            </div>
            <div
              className={css.edit}
              onClick={() => {
                editInformation(record);
              }}>
              Edit
            </div>
          </div>
        ),
      },
];
